import React from 'react';
import { type CommentsProps } from '@wix/comments-ooi-client';
import { type IHostProps } from '@wix/yoshi-flow-editor';

type RootProps = { host: IHostProps } & CommentsProps;

export const RootPropsContext = React.createContext<RootProps>(null!);
